import { CustomerGateway } from '../domain/customer.gateway';
import { SearchCustomerInterface } from '../domain/customer.entity';

export class SearchbyRneUseCase {
    constructor(private gate: CustomerGateway) {}

    async execute(rne: string): Promise<SearchCustomerInterface> {
        return this.gate.searchByRne(rne);
    }
}
